// InvoicingPage.jsx
import React, { useEffect, useRef, useState } from "react";
import AutoDismissAlert from "../../components/autoDismiss";
import { IfAllowed } from "../../components/permissions";
import ModalViewInvoice from "../components/modalViewInvoice";
import ModalResendInvoice from "../components/modalResendInvoice";
import ModalRunInvoicingProcess from "../components/ModalRunInvoicingProcess";
import { useInvoicing } from "../invoiceContext";
import { Form } from "react-bootstrap";

const InvoicingPage = () => {
  const invoicingContext = useInvoicing();

  const [invoicesList, setInvoicesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchInvoices = () => {
    setIsLoading(true);
    try {
      // Datos fake de ejemplo
      const fakeInvoices = [
        {
          id: 1,
          invoice_number: "INV-2025-001",
          entry_id: 12345,
          date: "2025-12-01T10:00:00Z",
          total: 1200.5,
        },
        {
          id: 2,
          invoice_number: "INV-2025-002",
          entry_id: 12346,
          date: "2025-12-02T11:30:00Z",
          total: 850.0,
        },
        {
          id: 3,
          invoice_number: "INV-2025-003",
          entry_id: 12347,
          date: "2025-12-03T09:15:00Z",
          total: 430.75,
        },
      ];
      setInvoicesList(fakeInvoices);
    } catch (error) {
      invoicingContext.setMessage(
        "Ha ocurrido un error cargando las facturas fake"
      );
      invoicingContext.setAlertType("danger");
      invoicingContext.openAlertHeader();
      console.error("Error getting fake invoices:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, [invoicingContext.apiSuccess]);

  return (
    <>
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar">
          <div
            id="kt_app_toolbar_container"
            className="app-container container-fluid d-flex flex-stack"
          >
            <div className="page-title d-flex flex-column justify-content-center me-3 mb-6 mb-lg-0">
              <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center me-3 mb-3 my-0">
                Invoicing
              </h1>
            </div>
          </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div
            id="kt_app_content_container"
            className="app-container container-fluid"
          >
            {invoicingContext.showAlertHeader && (
              <div className="">
                <AutoDismissAlert
                  message={invoicingContext.message}
                  alertType={invoicingContext.alertType}
                  onClose={invoicingContext.closeAlertHeader}
                />
              </div>
            )}

            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <div
                  className="spinner-grow text-color-amarillo-livensa"
                  style={{ width: "5rem", height: "5em" }}
                  role="status"
                ></div>
              </div>
            ) : (
              <div className="card">
                {/* === AQUÍ VA EL BOTÓN ARRIBA A LA DERECHA, COMO EN RulesPage === */}
                <IfAllowed
                  require={{
                    allOf: [
                      { module: "rules" },
                      { module: "rules", action: "can_edit_rules" },
                    ],
                  }}
                >
                  <div className="card-header border-0 pt-6">
                    <div className="card-title">
                      <div className="d-flex align-items-center position-relative my-1"></div>
                      <span className="card-label fw-bold text-gray-900">
                        <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                          <div className="d-flex">
                            <Form
                              className="d-flex"
                              onSubmit={(e) => {
                                e.preventDefault();
                              }}
                            >
                              <Form.Control
                                className="m-3 d-flex align-items-center"
                                placeholder="Buscar invoice"
                                type="text"
                              />
                              <Form.Control
                                className="m-3 d-flex align-items-center"
                                type="date"
                              />
                            </Form>
                          </div>
                        </div>
                      </span>
                    </div>

                    <div className="card-toolbar">
                      <div
                        className="d-flex justify-content-end"
                        data-kt-user-table-toolbar="base"
                      >
                        <a
                          onClick={() => invoicingContext.openRunProcessModal()}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="icon-in-button-color fa-solid fa-file-invoice-dollar"></i>
                          Ejecutar Proceso de Invoicing
                        </a>
                      </div>
                    </div>
                  </div>
                </IfAllowed>

                <div className="card-body py-4">
                  <div
                    id="kt_table_invoices_wrapper"
                    className="dataTables_wrapper dt-bootstrap4 no-footer"
                  >
                    <div className="table-responsive">
                      <table
                        className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer w-100"
                        id="kt_table_invoices"
                      >
                        <thead>
                          <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                            <th>Invoice Number</th>
                            <th>EntryID</th>
                            <th>Fecha</th>
                            <th>Descargar</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold">
                          {invoicesList.map((invoice, index) => (
                            <tr key={index}>
                              <td>{invoice.invoice_number}</td>
                              <td>{invoice.entry_id}</td>
                              <td>
                                {invoice.date
                                  ? new Date(invoice.date).toLocaleDateString()
                                  : "-"}
                              </td>
                              <td>
                                <a
                                  href={invoice.download_link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="icon-in-button-color fa-solid fa-download text-amarillo-livensa"></i>
                                </a>
                              </td>
                              <td>
                                <TableActions invoice={invoice} />
                              </td>
                            </tr>
                          ))}
                          {invoicesList.length === 0 && (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No hay facturas para mostrar
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Paginación futura si la necesitas */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {invoicingContext.showViewInvoiceModal && (
        <ModalViewInvoice
          onClose={invoicingContext.closeViewInvoiceModal}
          invoice={invoicingContext.selectedInvoice}
        />
      )}

      {invoicingContext.showResendInvoiceModal && (
        <ModalResendInvoice
          onClose={invoicingContext.closeResendInvoiceModal}
          invoice={invoicingContext.selectedInvoice}
        />
      )}

      {invoicingContext.showRunProcessModal && (
        <ModalRunInvoicingProcess
          onClose={invoicingContext.closeRunProcessModal}
        />
      )}
    </>
  );
};

export default InvoicingPage;

const TableActions = ({ invoice }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const menuRef = useRef(null);
  const anchorRef = useRef(null);
  const invoicingContext = useInvoicing();

  const toggleDropdown = (e) => {
    e.preventDefault();
    setShowMenu(!showMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  useEffect(() => {
    if (showMenu && anchorRef.current) {
      const anchorRect = anchorRef.current.getBoundingClientRect();
      const elementWidth = anchorRef.current.offsetWidth;
      const screenWidth = window.innerWidth;
      const menuX = anchorRect.left - screenWidth + elementWidth;
      const menuY = anchorRect.top + anchorRect.height + 10;
      setMenuPosition({ x: menuX, y: menuY });
    }
  }, [showMenu]);

  return (
    <>
      <a
        href="#"
        className="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary show menu-dropdown"
        onClick={toggleDropdown}
        data-kt-menu-trigger="click"
        data-kt-menu-placement="bottom-end"
        ref={anchorRef}
      >
        Acciones
        <i className="ki-outline ki-down text-color-azul-livensa fs-5 ms-1"></i>
      </a>
      <div
        ref={menuRef}
        style={{
          transform: `translate3d(${menuPosition.x}px, ${menuPosition.y}px, 0)`,
        }}
        className={`menu-actions-table menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-175px py-4 ${
          showMenu ? "show" : ""
        }`}
        data-kt-menu="true"
        data-popper-placement="bottom-end"
      >
        <div className="menu-item px-3">
          <a
            onClick={() => {
              invoicingContext.openViewInvoiceModal(invoice);
              setShowMenu(false);
            }}
            className="menu-link px-3"
          >
            Ver factura
          </a>
        </div>
        <div className="menu-item px-3">
          <a
            onClick={() => {
              invoicingContext.openResendInvoiceModal(invoice);
              setShowMenu(false);
            }}
            className="menu-link px-3"
          >
            Reenviar factura
          </a>
        </div>
      </div>
    </>
  );
};
